import { FaQuoteLeft } from "react-icons/fa";

export default function QuoteIcon({ size }) {
    return <FaQuoteLeft size={size} />;
}